import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/ai-deepseek",
    name: "ai-deepseek",
    component: () => import("@/views/ai-deepseek/index.vue"),
    meta: {
      title: "智能答疑中心-融跃教育",
      keywords: "CFA答疑,FRM答疑,ACCA答疑,CPA答疑,CMA答疑,AI答疑",
      description: "融跃教育在线答疑中心，为广大学员提供在线答疑服务。经验丰富的老师们在线为你快速解决CFA、FRM、ACCA、CPA、CMA及会计职称等各类财经会计备考学习中的疑难问题，提高你的学习效率。",
    },
  },
  {
    path: "/ai-knowledge-base",
    name: "ai-knowledge-base",
    component: () => import("@/views/ai-knowledge-base/index.vue"),
    meta: {
      title: "智能答疑中心-融跃教育",
      keywords: "CFA答疑,FRM答疑,ACCA答疑,CPA答疑,CMA答疑,AI答疑",
      description: "融跃教育在线答疑中心，为广大学员提供在线答疑服务。经验丰富的老师们在线为你快速解决CFA、FRM、ACCA、CPA、CMA及会计职称等各类财经会计备考学习中的疑难问题，提高你的学习效率。",
    },
  },
  {
    path: "*",
    redirect: "/ai-deepseek",
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;
